<template>
  <button
    type="button"
    class="disabled:cursor-not-allowed disabled:opacity-50 inline-flex gap-2 justify-center items-center rounded-md border border-transparent px-[18px] py-2.5 text-base font-semibold shadow-sm sm:text-sm"
    :class="{
      'bg-brand-900 text-white hover:bg-brand-800 focus:outline-brand-800 focus:bg-brand-800/80':
        !buttonStyle || buttonStyle === 'primary',
      'bg-white text-brand-900 hover:bg-gray-100 focus:outline-none focus:shadow-[0px_0px_0px_4px_rgba(242,244,247,0.50),0px_1px_2px_0px_rgba(16,24,40,0.05)]':
        buttonStyle === 'secondary',
    }"
    @click="click"
    :disabled="props.loading || props.disabled === true"
  >
    <component
      :is="props.icon"
      class="h-5 w-5"
      aria-hidden="true"
      v-if="props.icon && !props.loading"
      :class="{
        'order-first': props.iconPosition === 'left',
        'order-last': props.iconPosition === 'right',
      }"
    />
    <svg
      v-if="loading"
      class="animate-spin h-4 w-4 -ml-1 mr-2"
      :class="{
        'text-white': !buttonStyle || buttonStyle === 'primary',
        'text-brand-900': buttonStyle === 'white',
      }"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      ></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
    <span v-if="!props.loading">{{ props.label }}</span>
    <span v-else>{{ props.loadingLabel || props.label }}</span>
    <slot />
  </button>
</template>

<script setup>
import { defineEmits, defineProps } from "vue";

const props = defineProps({
  label: String,
  icon: Function,
  iconPosition: {
    type: String,
    default: "left",
  },
  loading: Boolean,
  loadingLabel: String,
  disabled: Boolean,
  buttonStyle: String,
});

const emit = defineEmits(["click"]);
const click = () => emit("click");
</script>
